import NotificationsBell from './NotificationsBell'

export default NotificationsBell
// eslint-disable-next-line import/export
export * from './NotificationsBell'
